function Error() {
  return (
    <div className="error">
      <p>Oops, Somethimg went wrong!</p>
    </div>
  );
}

export default Error;
